import { InlineTextField } from "@/components/shared/inputs/inilie-text-field/InlineTextField";
import { CollapsibleFieldList } from "../../../parts/CollapsibleFieldList";
import { FieldGroup, OptionalFieldGroup } from "../../../parts/FieldGroup";

interface AskAiSettingsProps {
  enabled: boolean;
  placeholder: string;
  onEnabledChange: (nextValue: boolean) => void;
  onPlaceholderChange: (value: string) => void;
}

export function AskAiSettings({
  enabled,
  placeholder,
  onEnabledChange,
  onPlaceholderChange,
}: AskAiSettingsProps) {
  return (
    <CollapsibleFieldList title={"Ask AI Input"} defaultOpen>
      <OptionalFieldGroup
        label={"Show Ask AI input"}
        description={"Let users start a chat from the home screen."}
        enabled={enabled}
        toggleEnabled={onEnabledChange}
      />
      <FieldGroup horizontal description={"Placeholder"}>
        <InlineTextField
          value={placeholder}
          onChange={onPlaceholderChange}
          placeholder={"Ask anything..."}
          disabled={!enabled}
        />
      </FieldGroup>
    </CollapsibleFieldList>
  );
}
